import jsCookie from 'js-cookie';
import { jwtCookieName } from 'types/accessControl/AccessControlConstants';

export const getDefaultJWTCookie = () => jsCookie.get(jwtCookieName);
